<template>
  <div>
    <div class="register-card mdl-card mdl-shadow--2dp" v-show="isVisible">
      <div class="ga-form-title">
        <h2 class="ga-title-text" v-if="withCredentials">{{'register.label.title' | label}}</h2>
        <h2 class="ga-title-text" v-else>{{'register.label.sender' | label}}</h2>
      </div>
      <div class="mdl-card__supporting-text fill">
        <validator name="registerValidator" :groups="['firstLastOrNickGroup']">
          <form novalidate>
            <div class="cell-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
              <input class="mdl-textfield__input" type="text" id="nickname" v-model="user['nickname']" initial="off"
                     v-validate:nickname="['required']" @keyup="clearUsernameValidation()">
              <label class="mdl-textfield__label ga-required" for="lastName">{{'register.label.nickname' | label}}</label>
              <span class="validation-error mdl-textfield__error" v-if="$registerValidator.nickname.required">{{'register.validation.nickname.required' | label}}</span>
              <span class="validation-error mdl-textfield__error" v-if="showUsernameValidation">{{usernameValidationMessage | label}} {{ usernameSuggestions.length ? 'register.instruction.usernameSuggestion' : '' | label}} {{ usernameSuggestions.join(', ') }}</span>
              <span class="ga-input-instruction" v-if="!$registerValidator.nickname.required && !showUsernameValidation">{{'register.instruction.nickname' | label}}</span>
            </div>
            <div class="cell-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
              <div class="iconized">
                <input class="mdl-textfield__input" :type="emailInputType" id="email" v-model="user['email']" initial="off"
                      v-validate:email="['required', 'email']" @keyup="clearEmailValidation()">
                <span class="fas" :class="{'fa-eye': isFaEye, 'fa-eye-slash': isFaEyeSlash}"  @click="toggleShowEmail">&nbsp;</span>
              </div>
              <label class="mdl-textfield__label ga-required" for="email">{{'register.label.email' | label}}</label>
              <span class="validation-error mdl-textfield__error" v-if="$registerValidator.email.required">{{'register.validation.email.required' | label}}</span>
              <span class="validation-error mdl-textfield__error" v-if="$registerValidator.email.email">{{'register.validation.email.format' | label}}</span>
              <span class="validation-error mdl-textfield__error" v-if="showEmailValidation">{{emailValidationMessage | label}}</span>
              <span class="ga-input-instruction" v-if="!$registerValidator.email.required && !$registerValidator.email.email && !showEmailValidation">{{'register.instruction.email' | label}}</span>
            </div>
            <div v-if="!withCredentials" class="cell-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
              <input class="mdl-textfield__input" type="email" id="emailConfirmation" v-model="user['emailConfirmation']" initial="off"
                     v-validate:emailConfirmation="{required: true, isEqual: getEmail}">
              <label class="mdl-textfield__label ga-required" for="email">{{'register.label.email.confirmation' | label}}</label>
              <span class="validation-error mdl-textfield__error" v-if="$registerValidator.emailconfirmation.required">{{'register.validation.emailConfirmation.required' | label}}</span>
              <span class="validation-error mdl-textfield__error" v-if="user['emailConfirmation'] && $registerValidator.emailconfirmation.isEqual">{{'register.validation.emailConfirmation.isEqual' | label}}</span>
              <span class="ga-input-instruction" v-if="!$registerValidator.emailconfirmation.required && !$registerValidator.emailconfirmation.isEqual">{{'register.instruction.emailconfirmation' | label}}</span>
            </div>
            <div class="cell-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
              <input class="mdl-textfield__input" type="text" id="firstName" v-model="user['firstName']" initial="off"
                     group="firstLastOrNickGroup" @touched="firstLastOrNickModified" v-validate:firstName="{firstLastOrNick: getUser}">
              <label class="mdl-textfield__label" for="firstName">{{'register.label.firstName' | label}}</label>
              <span class="validation-error mdl-textfield__error" v-if="$registerValidator.firstLastOrNickGroup.invalid">{{'register.validation.firstLastOrNick' | label}}</span>
              <span class="ga-input-instruction" v-if="!$registerValidator.firstLastOrNickGroup.invalid">{{'register.instruction.firstLastOrNick' | label}}</span>
            </div>
            <div class="cell-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
              <input class="mdl-textfield__input" type="text" id="lastName" v-model="user['lastName']" initial="off"
                     group="firstLastOrNickGroup" @touched="firstLastOrNickModified" v-validate:lastName="{firstLastOrNick: getUser}">
              <label class="mdl-textfield__label" for="lastName">{{'register.label.lastName' | label}}</label>
              <span class="validation-error mdl-textfield__error" v-if="$registerValidator.firstLastOrNickGroup.invalid">{{'register.validation.firstLastOrNick' | label}}</span>
              <span class="ga-input-instruction" v-if="!$registerValidator.firstLastOrNickGroup.invalid">{{'register.instruction.lastname' | label}}</span>
            </div>
            <div v-if="withCredentials">
              <!--<div class="cell-textfield mdl-textfield mdl-js-textfield mdl-textfield&#45;&#45;floating-label fill">-->
                <!--<input class="mdl-textfield__input" type="phone" id="phone" v-model="user['phone']" initial="off"-->
                       <!--v-validate:phone="['phone']">-->
                <!--<label class="mdl-textfield__label" for="phone">{{'register.label.phone' | label}}</label>-->
                <!--<span class="validation-error mdl-textfield__error" v-if="$registerValidator.phone.phone">{{'register.validation.phone' | label}}</span>-->
              <!--</div>-->
              <div class="mdl-grid inner-grid">
                <!-- <div class="mdl-cell mdl-cell--12-col padding-top center-text"> -->
                <div class="mdl-cell mdl-cell--12-col">
                  <!-- <div class="padding-top center-text"> -->
                  <div>
                    <label v-el:noPhoneCheckbox class="mdl-checkbox mdl-js-checkbox ga-required ga-inline" for="nophone" >
                      <input type="checkbox" id="nophone" class="mdl-checkbox__input" name="nophone" value="{{noPhone}}"
                            initial="off" v-model="noPhone">
                    <span class="mdl-checkbox__label">
                      {{'register.label.noPhone' | label}}
                    </span>
                    <span class="ga-input-instruction">{{'register.instruction.noPhone' | label}}</span>
                    </label>
                  </div>
                </div>
                <div class="mdl-cell mdl-cell--6-col">
                  <div v-el:phoneCodeEl class="cell-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill dirty-check">
                    <!-- <input :disabled="noPhone ? true : null" class="mdl-textfield__input" type="number" id="phoneCode" v-model="phoneCode" initial="off"
                           v-validate:phoneCode="{phoneCode: getNoPhone}"> -->
                    <mdl-select id="phoneCode" name="phoneCode"
                    :value.sync="phoneCode"
                    :lookup-object.sync="dialCode"
                    :clear.sync="clearPhoneCode"
                    options="DIAL_CODE" initial="off"
                    autocomplete
                    :disabled="noPhone"
                    v-validate:phoneCode="{phoneCode: getPhoneCode}"></mdl-select>
                    <label class="mdl-textfield__label" for="phoneCode">{{'register.label.phoneCode' | label}}</label>
                    <span class="validation-error mdl-textfield__error" v-if="$registerValidator.phonecode.phoneCode && !noPhone">{{'register.validation.phoneCode' | label}}</span>
                    <span class="ga-input-instruction" v-if="!$registerValidator.phonecode.phoneCode">{{'register.instruction.phoneCode' | label}}</span>
                  </div>
                </div>
                <div class="mdl-cell mdl-cell--6-col">
                  <div v-el:phoneNumberEl class="cell-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
                    <input :disabled="noPhone" class="mdl-textfield__input" type="number" id="phoneNumber" v-model="phoneNumber" initial="off"
                           v-validate:phoneNumber="{phoneNumber: getNoPhone}">
                    <label class="mdl-textfield__label" for="phoneNumber">{{'register.label.phone' | label}}</label>
                    <span class="validation-error mdl-textfield__error" v-if="$registerValidator.phonenumber.phoneNumber && !noPhone">{{'register.validation.phone' | label}}</span>
                    <span class="ga-input-instruction" v-if="!$registerValidator.phonenumber.phoneNumber">{{'register.instruction.phoneNumber' | label}}</span>
                  </div>
                </div>
                <div class="mdl-cell mdl-cell--12-col">
                    <span class="ga-input-instruction" v-if="!$registerValidator.phonenumber.phoneNumber && !$registerValidator.phonecode.phoneCode">
                      {{'register.instruction.phone' | label}}</span>
                </div>
              </div>
            </div>
              <div class="mdl-grid inner-grid">
                <div class="mdl-cell mdl-cell--4-col">
                  <label class="delivery-label ga-required" for="timeZone">{{'register.label.timeZone' | label}}</label>
                </div>
                <div class="mdl-cell mdl-cell--8-col">
                  <mdl-select name='timeZone' :value.sync="user['timeZone']" options="TIME_ZONE"
                              autocomplete
                              :preselected.sync="defaultTimeZone" ></mdl-select>
                </div>
                <span class="ga-input-instruction">{{'register.instruction.timezone' | label}}</span>
              </div>
                <!--v-validate:timeZone="['required']"-->
                <!--<span class="validation-error mdl-textfield__error" v-if="$registerValidator.timezone-select.required">{{'register.validation.timeZone' | label}}</span>-->
            <!--</template>-->
            <div v-if="withCredentials">
              <div class="cell-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
                <input class="mdl-textfield__input" type="password" id="password" v-model="credentials['password']"
                       initial="off" v-validate:password="['password']" @keyup="clearPasswordValidation()">
                <label class="mdl-textfield__label ga-required" for="password">{{'register.label.password' | label}}</label>
                <span class="validation-error mdl-textfield__error" v-if="$registerValidator.password.password">{{'register.validation.password' | label}}</span>
                <span class="validation-error mdl-textfield__error" v-if="showPasswordValidation">{{passwordValidationMessage | label}}</span>
                <span class="ga-input-instruction" v-if="!showPasswordValidation && !$registerValidator.password.password">{{'register.instruction.password' | label}}</span>
              </div>
              <div class="cell-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
                <input class="mdl-textfield__input" type="password" id="confirmPassword" v-model="user['confirmPassword']"
                       initial="off" v-validate:confirmPassword="{isEqual: getPassword}" @keyup="clearConfirmPasswordValidation()">
                <label class="mdl-textfield__label ga-required" for="confirmPassword">{{'register.label.confirmPassword' | label}}</label>
                <span class="validation-error mdl-textfield__error" v-if="$registerValidator.confirmpassword.isEqual">{{'register.validation.confirmPassword' | label}}</span>
                <span class="validation-error mdl-textfield__error" v-if="showConfirmPasswordValidation">{{confirmPasswordValidationMessage | label}}</span>
                <span class="ga-input-instruction" v-if="!showConfirmPasswordValidation && !$registerValidator.confirmpassword.isEqual">{{'register.instruction.confirmPassword' | label}}</span>
              </div>
            </div>
            <div class="mdl-grid inner-grid">
              <div class="mdl-cell mdl-cell--12-col">
                <label v-el:termsLabel class="mdl-checkbox mdl-js-checkbox ga-required" for="terms">
                  <input type="checkbox" id="terms" class="mdl-checkbox__input" name="terms" value="{{acceptedTerms}}"
                    initial="off" v-model="acceptedTerms" v-validate:terms="{
                      minlength: { rule: 1 }
                    }">
                  <span class="mdl-checkbox__label">
                    {{'register.label.accept' | label}}
                    <a href="#" v-on:click="showTermsAndConditions()">{{{'register.label.terms.condition' | label}}}</a>
                  </span>
                </label>
                <span class="validation-error mdl-textfield__error" v-if="$registerValidator.terms.invalid">{{'register.validation.terms' | label}}</span>
                <span class="ga-input-instruction" v-if="!$registerValidator.terms.invalid">{{'register.instruction.terms' | label}}</span>
              </div>
            </div>
            <div id="captcha-root">
              <vue-recaptcha v-ref:recaptcha v-on:verify="onVerify" v-on:expired="onExpired" :options="opts"></vue-recaptcha>
              <span class="validation-error mdl-textfield__error margin-bottom" v-if="showCaptchaValidation">{{'register.validation.recaptcha' | label}}</span>
            </div>
          </form>
        </validator>
      </div>
      <div v-if="withCredentials">
        <div class="mdl-card__actions">
          <div class="card-grid mdl-grid">
            <div class="mdl-cell mdl-cell--8-col">
            </div>
            <div class="mdl-cell mdl-cell--4-col">
              <div class="submit-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
                v-on:click="validate(user, credentials)">
                {{'register.button.register' | label}}
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  <div v-show="showTerms" class="modal-big" transition="fade">
    <div class="mdl-dialog scrollbar">
      <h3 class="mdl-dialog__title">{{{ 'register.termsAndConditions.title' | label }}}</h3>
      <div class="mdl-dialog__content ga-no-padding">
        <p>
          {{{ 'register.termsAndConditions.text' | label }}}
        </p>
        <hr>
        <p>
          {{{ 'register.privacyAndCookiesPolicy.text' | label }}}
        </p>
      </div>
      <div class="mdl-dialog__actions">
        <div class="mdl-button mdl-js-button mdl-button--colored"
             v-on:click="closeTermsDialog()">{{ 'general.button.cancel' | label}}</div>
        <div class="mdl-button mdl-js-button mdl-button--colored" v-on:click="acceptTerms()">{{ 'general.button.accept' | label}}</div>
      </div>
    </div>
  </div>
  <div v-show="error.show" class="modal" transition="fade">
    <div class="mdl-dialog">
      <h3 class="mdl-dialog__title">{{ }}</h3>
      <div class="mdl-dialog__content">
        <p>
          {{ error.message | label }}
        </p>
      </div>
      <div class="mdl-dialog__actions">
        <div class="mdl-button mdl-js-button mdl-button--colored"><a v-link="{path: '/login'}">{{ 'register.button.dialog.login' | label}}</a></div>
        <div class="mdl-button mdl-js-button mdl-button--colored"
             v-on:click="closeErrorDialog()">{{ 'register.button.dialog.proceed' | label}}</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  var api = require('api')
  var config = require('common/config')
  var vueRecaptcha = require('c/components/recaptcha/recaptcha.vue')
  module.exports = {
    props: {
      withCredentials: Boolean,
      isVisible: {
        'type': Boolean,
        'default': true
      }
    },
    components: {
      'mdl-select': require('c/components/Select'),
      'datepicker': require('c/components/Datepicker'),
      'vue-recaptcha': vueRecaptcha
    },
    methods: {
      validate: function (user, credentials) {
        var self = this
        self.usernameSuggestions = []
        if (self.withCredentials) {
          api.User.available({
            username: user.nickname,
            email: user.email
          }).then(function (data) {
            self.validateForm(user, credentials)
          }, function (err) {
            if (err.data.message === 'register.error.usernameExists') {
              self.usernameValidationMessage = err.data.message
              self.showUsernameValidation = true
              self.error.show = false
              self.error.message = 'register.error.usernameExists.long'
              api.User.suggestUsername({
                username: user.nickname
              }).then(function (response) {
                self.usernameSuggestions = response.data.suggestions
              })
            } else if (err.data.message === 'register.validation.username.invalidStart') {
              self.usernameValidationMessage = err.data.message
              self.showUsernameValidation = true
            } else if (err.data.message === 'register.validation.username.invalidChars') {
              self.usernameValidationMessage = err.data.message
              self.showUsernameValidation = true
            } else if (err.data.message === 'register.validation.username.invalidLength') {
              self.usernameValidationMessage = err.data.message
              self.showUsernameValidation = true
            } else if (err.data.message === 'register.error.emailExists') {
              self.emailValidationMessage = err.data.message
              self.showEmailValidation = true
/*            self.error.show = true
              self.error.message = 'register.error.emailExists.long'
               */
            } else if (err.data.message === 'general.validation.error.emailFormat') {
              self.emailValidationMessage = err.data.message
              self.showEmailValidation = true
            } else {
              self.$dispatch('show-error', err.data)
            }
          })
        } else {
          self.validateForm(user, credentials)
        }
      },
      validateForm: function (user, credentials) {
        var self = this
        self.clearCaptchaValidation()
        self.$validate(true, function () {
          if (self.$registerValidator.invalid || !self.recaptcha) {
            if (self.$registerValidator.invalid) {
              self.resetRecaptcha()
            }
            if (!self.recaptcha) {
              self.showCaptchaValidation = true
            }
            return
          }
          credentials.username = user.nickname
          if (self.withCredentials) {
            if (!self.dialCode && !self.noPhone) {
              return
            }
            user.Credentials = credentials
            user.emailConfirmation = user.email
            if (!self.noPhone) {
              user.prefix = self.dialCode.key
              user.phone = self.phoneCode + '-' + self.phoneNumber.replace(/^[0]+/g, '')
            }
          }
          self.$dispatch('registration-valid', user)
        })
      },
      getNoPhone: function () {
        return this.noPhone
      },
      getPhoneCode: function () {
        if (this.noPhone) {
          return true
        }
        return this.dialCode
      },
      closeErrorDialog: function () {
        this.error.show = false
      },
      closeTermsDialog: function () {
        this.showTerms = false
      },
      firstLastOrNickModified: function () {
        this.$validate()
      },
      clearUsernameValidation: function () {
        this.usernameValidationMessage = ''
        this.showUsernameValidation = false
      },
      clearEmailValidation: function () {
        this.emailValidationMessage = ''
        this.showEmailValidation = false
      },
      clearPasswordValidation: function () {
        this.passwordValidationMessage = ''
        this.showPasswordValidation = false
      },
      clearConfirmPasswordValidation: function () {
        this.confirmPasswordValidationMessage = ''
        this.showConfirmPasswordValidation = false
      },
      getUser: function () {
        return this.user
      },
      getPassword: function () {
        return {
          password: this.credentials.password
        }
      },
      getEmail: function () {
        return {
          password: this.user.email
        }
      },
      showTermsAndConditions: function () {
        this.showTerms = true
      },
      acceptTerms: function () {
        this.$els.termslabel.classList.add('is-checked')
        this.acceptedTerms = true
        this.showTerms = false
      },
      clearCaptchaValidation: function () {
        this.showCaptchaValidation = false
      },
      onVerify: function (response) {
        this.recaptcha = true
        this.credentials.recaptchaData = response
        this.showCaptchaValidation = false
      },
      onExpired: function () {
        console.log('Expired')
      },
      resetRecaptcha: function () {
        this.$refs.recaptcha.reset() // Direct call reset method
        this.recaptcha = false
        // this.$broadcast('recaptchaReset'); // Or broadcast event
      },
      toggleShowEmail: function () {
        this.emailInputType = (this.isFaEye ? 'email' : 'password')
        this.isFaEye = !this.isFaEye
        this.isFaEyeSlash = !this.isFaEyeSlash
      }
    },
    events: {
      'username-validation-fail': function (data) {
        this.emailValidationMessage = data
        this.showEmailValidation = true
      },
      'password-validation-fail': function (data) {
        this.passwordValidationMessage = data
        this.showPasswordValidation = true
      },
      'confirm-password-validation-fail': function (data) {
        this.confirmPasswordValidationMessage = data
        this.showConfirmPasswordValidation = true
      },
      'validate-sender': function (message) {
        this.validate(this.user, this.credentials)
      }
    },
    data: function () {
      return {
        credentials: {
          username: '',
          password: ''
        },
        user: {
          email: '',
          firstName: '',
          lastName: '',
          nickname: '',
          langCode: '',
          prefix: null,
          phone: null,
          timeZone: '',
          confirmPassword: '',
          emailConfirmation: ''
        },
        phoneCode: '',
        phoneNumber: '',
        dialCode: undefined,
        acceptedTerms: false,
        showUsernameValidation: false,
        usernameValidationMessage: '',
        showEmailValidation: false,
        emailValidationMessage: '',
        showPasswordValidation: false,
        passwordValidationMessage: '',
        confirmPasswordValidationMessage: '',
        showConfirmPasswordValidation: false,
        noPhone: false,
        clearPhoneCode: false,
        showTerms: false,
        error: {
          show: false,
          message: ''
        },
        showCaptchaValidation: false,
        opts: {
          sitekey: config.recaptcha.sitekey
        },
        recaptcha: false,
        isFaEye: true,
        isFaEyeSlash: false,
        emailInputType: 'password',
        usernameSuggestions: []
      }
    },
    computed: {
      defaultTimeZone: function () {
        var moment = require('moment-timezone')
//        console.log(moment.tz.guess())
        return moment.tz.guess()
      }
    },
    watch: {
      'noPhone': function (newVal, oldVal) {
        if (newVal) {
          this.clearPhoneCode = true
          this.phoneCode = ''
          this.phoneNumber = ''
          this.$els.phonecodeel.classList.remove('is-dirty')
          this.$els.phonenumberel.classList.remove('is-dirty')
          this.$els.nophonecheckbox.classList.add('is-checked')
        } else {
          this.$els.nophonecheckbox.classList.remove('is-checked')
          this.clearPhoneCode = false
        }
      },
      'phoneCode': function (newVal, oldVal) {
        var self = this
        self.$validate('phonecode', true, function () {})
        if (newVal) {
          document.querySelectorAll('.dirty-check').forEach(function (el) {
            var input = el.querySelector('input') || el.querySelector('textarea')
            if (input && input.value) {
              el.MaterialTextfield.checkDirty()
            }
          })
        }
      },
      'dialCode': function (newVal, oldVal) {
        var self = this
        self.$validate('phonecode', true, function () {})
      }
    }
  }
</script>

<style scoped>
  .register-card {
    width: 100%;
  }
  .modal {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 220px;
    width: 400px;
    background-color: white;
    z-index: 1;
  }
  .mdl-dialog {
    width: 400px;
  }
  .modal-big {
    position: fixed;
    top: 80px;
    bottom: 120px;
    left: auto;
    right: auto;
    /* margin: 40px auto 60px auto; */
    background-color: white;
    z-index: 1;
    /* transform: translateX(-50%) translateY(-50%); */
    /* height: 100%; */
  }
  .modal-big .mdl-dialog {
    width: 90vw;
    height: 100%;
    overflow-y: auto;
  }
  @media (min-width: 840px){
    .modal-big .mdl-dialog {
      width: 40vw;
    }
  }
  a {
    text-decoration: none;
  }
  .center-text {
    margin-top: 35px;
  }
  .ga-inline {
    display: inline !important;
  }
</style>



// WEBPACK FOOTER //
// RegisterForm.vue?bbb26d74